<template>
  <audio id="audio" preload="auto" muted>
    <source
      src="../data/notifications-audio/notification.mp3"
      type="audio/mpeg"
    />
    <source
      src="../data/notifications-audio/notification.ogg"
      type="audio/ogg"
    />
  </audio>
</template>

<script>
export default {
  name: 'AudioNotification',
  methods: {
    playAudio() {
      const audio = document.querySelector('#audio');
      audio.play();
    },
  },
};
</script>
